module.exports = __webpack_public_path__ + "static/media/biomec.af6b8d17.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/aguacate/climasense/acaro_cafe_aguacate/curativa/biomec.png
// module id = 1075
// module chunks = 3